import { useEffect } from 'react';

import type { Dispatch, SetStateAction} from 'react';

import type { ProviderFilter } from '@travel/traveler-core/types/providerList';

import { DEFAULT_SORT_KEY } from '../../constants/defaultValue';

type Props = {
  features: string[];
  freeCancellation: boolean;
  isClearFilterButtonDisabled: boolean;
  maxPrice?: number | null;
  minPrice?: number | null;
  recentPriceFilter?: ProviderFilter;
  reviewRating: string[];
  setIsClearFilterButtonDisabled: Dispatch<SetStateAction<boolean>>;
  sortKey: string;
  starRating: string[];
};

const useClearFilterButton = ({
  features,
  freeCancellation,
  isClearFilterButtonDisabled,
  maxPrice,
  minPrice,
  recentPriceFilter,
  reviewRating,
  setIsClearFilterButtonDisabled,
  sortKey,
  starRating,
}: Props) => {
  useEffect(() => {
    const shouldEnableClearFilterButton =
      isClearFilterButtonDisabled &&
      ((minPrice && Math.floor(minPrice) !== Math.floor(recentPriceFilter?.min || 0)) ||
        (maxPrice && Math.floor(maxPrice) !== Math.floor(recentPriceFilter?.max || 0)) ||
        features.length > 0 ||
        starRating.length > 0 ||
        reviewRating.length > 0 ||
        sortKey !== DEFAULT_SORT_KEY ||
        freeCancellation);

    if (shouldEnableClearFilterButton) {
      setIsClearFilterButtonDisabled(false);
    }
  }, [
    isClearFilterButtonDisabled,
    minPrice,
    maxPrice,
    features,
    starRating,
    reviewRating,
    sortKey,
    freeCancellation,
    recentPriceFilter,
    setIsClearFilterButtonDisabled,
  ]);
};

export default useClearFilterButton;
